import { Component } from 'lucide-react'
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom'
import { GuestOnly, RequireAuth } from '@/components/auth-guard.tsx'
import { ThemeProvider } from '@/components/theme-provider.tsx'
import { ConfirmHost } from '@/components/ui/confirm.tsx'
import { FloatButton } from '@/components/ui/float-button.tsx'
import { ToastViewport } from '@/components/ui/toast.tsx'
import { AdminShell } from '@/layouts/admin-shell.tsx'
import { CampusPage } from '@/pages/campus-page.tsx'
import { HandoutPage } from '@/pages/handout-page.tsx'
import { LoginPage } from '@/pages/login-page.tsx'
import { NotFoundPage } from '@/pages/not-found-page.tsx'
import { ShowcasePage } from '@/pages/showcase-page.tsx'
import { StudentPage } from '@/pages/student-page.tsx'
import { TeacherPage } from '@/pages/teacher-page.tsx'

/**
 * 已登录壳层：渲染子路由；开发环境在非登录页展示组件预览入口。
 */
function AuthedShell() {
  return (
    <>
      <Outlet />
      {import.meta.env.DEV ? (
        <FloatButton
          to="/showcase"
          aria-label="打开组件预览"
          label="组件预览"
          icon={<Component className="size-5" aria-hidden />}
        />
      ) : null}
    </>
  )
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <GuestOnly>
                <LoginPage />
              </GuestOnly>
            }
          />
          <Route element={<RequireAuth />}>
            <Route element={<AuthedShell />}>
              <Route element={<AdminShell />}>
                <Route path="/" element={<CampusPage />} />
                <Route path="/teachers" element={<TeacherPage />} />
                <Route path="/students" element={<StudentPage />} />
                <Route path="/handouts" element={<HandoutPage />} />
              </Route>
              <Route path="/showcase" element={<ShowcasePage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastViewport />
      <ConfirmHost />
    </ThemeProvider>
  )
}
